import moment from 'moment-timezone';
import { createSelector } from 'reselect';

const getState = (state) => state.orders;

const getExternalProps = (_, orderId) => ({
  orderId,
});

const getOrdersIdsByDate = createSelector(
  getState,
  getExternalProps,
  (orders) =>
    orders.ids.reduce((acc, orderId) => {
      if (orders?.ordersById?.[orderId]?.start_time_from) {
        const key = orders.ordersById[orderId].start_time_from.split('T')[0];
        return { ...acc, [key]: [...(acc[key] || []), orderId] };
      }
      return acc;
    }, {})
);

const getRecurringOrdersIdsByStatus = createSelector(
  getState,
  getExternalProps,
  (orders) =>
    orders.ids.reduce(
      (acc, orderId) => {
        const today = moment();
        const end = moment(orders.ordersById[orderId].end_on);

        return {
          active: [...acc.active, ...(today.isAfter(end) ? [] : [orderId])],
          finished: [...acc.finished, ...(today.isAfter(end) ? [orderId] : [])],
        };
      },
      { active: [], finished: [] }
    )
);

const getOrderById = createSelector(
  getState,
  getExternalProps,
  (orders, { orderId }) => orders.ordersById[orderId]
);

const getAllOrders = createSelector(getState, (orders) =>
  Object.values((orders || {}).ordersById)
);

const getNumberOfOrdersLoaded = createSelector(
  getState,
  (orders) => orders.ids && orders.ids.length
);

const getCount = createSelector(getState, (orders) => orders.count);

const getPages = createSelector(getState, (orders) => orders.pages);

const isFetching = createSelector(getState, (orders) => orders.isFetching);
const getInternalReferences = createSelector(getOrderById, (order) =>
  order?.shipments?.map((shipment) => shipment.internal_reference)
);

const getIsSubmitting = createSelector(
  getState,
  (orders) => orders.isSubmitting
);

const getSearchText = createSelector(getState, (orders) => orders.searchText);

const getFilterUserId = createSelector(
  getState,
  (orders) => orders.user && orders.user.id
);

const getFilterUser = createSelector(
  getState,
  (orders) => orders.user && orders.user
);

const getFilterFirstPickupTime = createSelector(
  getState,
  (orders) => orders.first_pickup_time && orders.first_pickup_time
);

const getFilterLastDropoffTime = createSelector(
  getState,
  (orders) => orders.last_dropoff_time && orders.last_dropoff_time
);

export default {
  getRecurringOrdersIdsByStatus,
  getOrdersIdsByDate,
  getOrderById,
  getNumberOfOrdersLoaded,
  getCount,
  getPages,
  isFetching,
  getInternalReferences,
  getIsSubmitting,
  getSearchText,
  getFilterUserId,
  getFilterUser,
  getFilterFirstPickupTime,
  getFilterLastDropoffTime,
  getAllOrders,
};
